import {
  AppErrorCode,
  Context,
  Id,
  PaginatedResult,
  enumMapToSame,
  isAppError,
  mapDtoToEntity,
  throwNotImplemented,
} from '../../../common'
import { AddUserOpts, UpdateUserOpts, User, UserFindOptions, UserStatus, UsersService } from './users'
import { Api, HttpClient, UsersApi } from '../../../api'

function mapDtoToUser(dto: Api.User): User {
  return mapDtoToEntity({
    ...dto,
    passwordHash: '',
    status: enumMapToSame<Api.User.Status, UserStatus>(dto.status),
  })
}

/** Manage users on remote API server */
export class RemoteUsersService implements UsersService {
  private api: UsersApi

  constructor(httpClient: HttpClient) {
    this.api = new UsersApi(httpClient, undefined, '')
  }

  async findAll(ctx: Context, opts?: UserFindOptions | undefined): Promise<PaginatedResult<User>> {
    const result = await this.api.usersGetList(ctx, {
      ids: opts?.filter?.ids,
      municipalEntityId: opts?.filter?.municipalEntityId,
      cardIssuePointId: opts?.filter?.cardIssuePointId,
      roleId: opts?.filter?.roleId,
      search: opts?.filter?.search,
      statuses: opts?.filter?.statuses,
      aFrom: opts?.paging?.from,
      count: opts?.paging?.count,
      orderBy: opts?.order?.field,
      direction: opts?.order?.direction,
    })
    return {
      ...result.body,
      items: result.body.items.map(mapDtoToUser),
    }
  }

  async findByIdNonDeleted(ctx: Context, id: string): Promise<User | undefined> {
    const result = await this.api.usersGetList(ctx, { ids: [id], count: 1 })
    return result.body.items.length > 0 ? mapDtoToUser(result.body.items[0]) : undefined
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async findByEmail(ctx: Context, email: string): Promise<User | undefined> {
    throwNotImplemented('<91198b54>')
  }

  async findById(ctx: Context, id: string): Promise<User | undefined> {
    try {
      const result = await this.api.usersGetById(ctx, id)
      return mapDtoToUser(result.body.object)
    } catch (e) {
      if (isAppError(e) && e.code === AppErrorCode.OBJECT_NOT_FOUND) return
      throw e
    }
  }

  async add(ctx: Context, opts: AddUserOpts): Promise<Id> {
    const result = await this.api.usersAdd(ctx, opts)
    return result.body.id
  }

  async update(ctx: Context, id: string, opts: UpdateUserOpts): Promise<void> {
    await this.api.usersUpdate(ctx, id, opts)
  }

  async delete(ctx: Context, id: string): Promise<void> {
    await this.api.usersDelete(ctx, id)
  }
}
